import React from 'react';
import { useField } from 'formik';
import TextField from '@mui/material/TextField';

export type ValidateType = {
  required?: boolean;
  min?: number;
  max?: number;
  handleValidate?: (value: string) => string | undefined;
};

export const onValidate = (value: string, validate: ValidateType) => {
  if (!value && validate.required) {
    return `Заповніть поле`;
  }

  if (validate.min) {
    if (value.length < validate.min) {
      return `Мінімальне значення має бути ${validate.min}`;
    }
  }

  if (validate.max) {
    if (value.length > validate.max) {
      return `Максимальне значення має бути ${validate.max}`;
    }
  }

  if (typeof validate.handleValidate === 'function') {
    return validate.handleValidate(value);
  }
};

export interface IField {
  label?: string;
  required?: boolean;
  disabled?: boolean;
  name: string;
  children?: JSX.Element;
  style?: React.CSSProperties | undefined;
  maxLength?: number;
  handleValidate?: (value: string) => string | undefined;
}

export const InputFormik: React.FC<IField> = ({ maxLength, disabled, label, name, required, style, handleValidate }) => {
  const [field, meta] = useField({
    name,
    validate: (value) => onValidate(value, { required, max: maxLength, handleValidate }),
  });
  return (
    <TextField
      fullWidth
      style={style}
      disabled={disabled}
      label={label || ''}
      size="small"
      variant="outlined"
      error={meta.touched && !!meta.error}
      helperText={meta.touched && meta.error}
      inputProps={{ maxLength: maxLength }}
      {...field}
    />
  );
};
